export default {
  updateWorkorderBookingsInFlight: ({ commit }, bookings) => {
    commit('setWorkorderBookingsInFlight', bookings);
  },
};
